module.exports = __webpack_public_path__ + "static/media/logoorange.0d56446a.png";